import {StyleSheet} from 'react-native';
import Typography from '@shared/constants/Typography';

export const createTextTooltipStyles = (theme: any) =>
  StyleSheet.create({
    /** Outer wrapper — always relative + visible overflow so the absolute
     *  tooltip can escape any parent clip boundary. */
    wrapper: {
      position: 'relative',
      overflow: 'visible',
    },
    /** Dark rounded box that contains the tooltip text. */
    tooltipBox: {
      backgroundColor: theme?.tooltipBackground,
      borderRadius: Typography.radius.radius4,
      padding: Typography.padding.padding12,
    },
    /** Text inside the tooltip bubble. */
    tooltipText: {
      color: theme?.tooltipText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.inter,
      textAlign: Typography.textAlign.centerAlign,
    },
    /** Container for the SVG arrow pointing downward — used when placement is 'above'. */
    arrowDown: {
      alignSelf: 'center' as const,
    },
    /** Container for the SVG arrow pointing upward — used when placement is 'below'. */
    arrowUp: {
      alignSelf: 'center' as const,
    },
  });